import React, { useEffect } from 'react'

import TWControls from '../controls/TWControls'
import { Form, useForm } from '../controls/useForm'

const DetailAddPopup = ({ addDetail, recordForEdit }) => {
	const detailTypes = [
		{ selectValue: 'Text' },
		{ selectValue: 'Number' },
		{ selectValue: 'Currency' },
		{ selectValue: 'Date' },
	]

	const detail = recordForEdit
	const initialValues = {
		...detail,
	}

	const validate = () => {
		let temp = { ...errors }
		temp.detailLabel = values.detailLabel ? '' : 'This field is required.'

		setErrors({
			...temp,
		})

		return Object.values(temp).every(x => x === '')
	}

	const { values, setValues, errors, setErrors, handleInputChange, resetForm } = useForm(
		initialValues,
		true,
		validate,
	)

	const submitHandler = e => {
		e.preventDefault()
		if (validate()) {
			addDetail(values, resetForm)
		}
	}

	useEffect(() => {
		if (detail != null) setValues({ ...detail })
	}, [detail, setValues])

	return (
		<Form onSubmit={submitHandler}>
			<div className="grid grid-cols-12 gap-4">
				<div className="col-span-12">
					<TWControls.Input
						name="detailLabel"
						label="Detail Label"
						value={values.detailLabel}
						onChange={handleInputChange}
						error={errors.detailLabel}
					/>
					<TWControls.SelectType
						name="detailType"
						label="Detail Type"
						value={values.detailType}
						onChange={handleInputChange}
						options={detailTypes}
						error={errors.detailType}
					/>

					{values.detailType === 'Date' ? (
						<TWControls.DatePicker
							name="detail"
							label="Initial Date"
							value={values.detail}
							onChange={handleInputChange}
							error={errors.detail}
						/>
					) : (
						<TWControls.Input
							name="detail"
							label="Initial Value"
							value={values.detail}
							onChange={handleInputChange}
							error={errors.detail}
						/>
					)}
				</div>
				<div className="col-span-12">
					<div className="newLocation__imageHolder">
						<TWControls.Button size="small" type="submit" text="Add Detail" />
					</div>
				</div>
			</div>
		</Form>
	)
}

export default DetailAddPopup
